module.exports = __webpack_public_path__ + "static/media/art-lives-here.bd7d67a6.png";